import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">
          媒体聚焦
        </h2>
        <p className="text-sm text-foreground-500 mb-8">精彩视频内容推荐</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaData.map((item) => (
            <article
              key={item.id}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 group cursor-pointer"
            >
              <div className="relative overflow-hidden h-[200px]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width="800"
                  height="500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center bg-background-50/90 rounded-full group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-primary-600 text-xl ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 text-xs font-medium bg-foreground-950/80 text-background-50 rounded whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-950 font-heading mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}次
                  </span>
                  <span>{item.date}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}